export default __webpack_public_path__ + "static/media/Fixxo..06fb1221.svg";